import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    whiteLabel: {
      namespaced: true,
      state: {
        font: "",
        showHeading: true,
        primaryColor: "#319795",
        secondaryColor: "#2d3748",
        domainWhiteList: []
      },
      mutations: {
        SET_PRIMARY_COLOR(state, color) {
          state.primaryColor = color;
        },
        SET_SECONDARY_COLOR(state, color) {
          state.secondaryColor = color;
        },
        SET_DOMAIN_WHITE_LIST(state, domains) {
          state.domainWhiteList = domains;
        },
        SET_HEADING(state, heading) {
          if (heading) {
            state.showHeading = true;
          } else {
            state.showHeading = false;
          }
        }
      },
      actions: {
        async setTheme({ commit }, agencyId) {
          await Vue.prototype.$http
            .get("/branding?id=" + agencyId)
            .then((response: any) => {
              /* eslint-disable */
              commit("SET_PRIMARY_COLOR", response.data.data.white_label_theme_config.theme.primary_color)
              commit("SET_SECONDARY_COLOR", response.data.data.white_label_theme_config.theme.secondary_color)
              commit("SET_HEADING", response.data.data.white_label_theme_config.market_analyzer.show_heading),
              commit("SET_DOMAIN_WHITE_LIST", response?.data?.data.white_label_theme_config?.market_analyzer?.domain_white_list)
              /* eslint-enable */
            })
            .catch((error: any) => {
              console.log(error);
            });
        }
      },
      getters: {
        primaryColor: state => {
          return state.primaryColor;
        },
        secondaryColor: state => {
          return state.secondaryColor;
        },
        showHeading: state => {
          return state.showHeading;
        },
        domainWhiteList: state => {
          return state.domainWhiteList;
        }
      }
    }
  }
});
